export default __webpack_public_path__ + "static/media/facebook.447953c2.svg";